import Button, { ButtonType } from 'components/Button';
import Cart from 'icons/Cart';
import Share from 'icons/Share';
import styles from './styles/PhotoGalleryActions.module.scss';
import { usePhotoGalleryContainer } from '..';

type PhotoGalleryActionsProps = {
  buttonType: ButtonType;
  iconColor: string;
};

export default function PhotoGalleryActions({ buttonType, iconColor }: PhotoGalleryActionsProps) {
  const [{ selectedPhotos }, { setShowCart, handleShareGallery }] = usePhotoGalleryContainer();

  const cartCount = selectedPhotos.length;

  return (
    <div className={`${styles.Container} ${cartCount ? styles.ContainerPad : ''}`}>
      {/* <Button
        label={
          <>
            <Like color={iconColor} height={11} width={13} className={styles.Icon} /> Like
          </>
        }
        type={buttonType}
        className={styles.LikeButton}
      /> */}
      <Button
        label={
          <>
            <Share color={iconColor} height={12.39} width={12.39} className={styles.Icon} /> Share
          </>
        }
        type={buttonType}
        className={styles.ShareButton}
        onClick={handleShareGallery}
      />
      <Button
        label={
          <>
            <Cart color={iconColor} height={14.34} width={16} />
            {cartCount ? `(${cartCount})` : null}
          </>
        }
        type={buttonType}
        className={`${styles.CartButton} ${cartCount ? styles.CartBadge : ''}`}
        onClick={() => setShowCart(true)}
      />
    </div>
  );
}
